import pcRoutes from '@/router/routes/pc-router'

const routes = [
  ...pcRoutes,
]

export default routes
